import React, { memo } from 'react'
import {
  UseFieldArrayReturn,
  FieldValues,
  FieldArrayPath,
} from 'react-hook-form'

interface FieldArrayControlsProps<
  TFieldValues extends FieldValues,
  TFieldArrayName extends FieldArrayPath<TFieldValues>,
> {
  index: number
  fieldArray: UseFieldArrayReturn<TFieldValues, TFieldArrayName>
  onClone?: () => void
}

const FieldArrayControlsComponent = <
  TFieldValues extends FieldValues,
  TFieldArrayName extends FieldArrayPath<TFieldValues>,
>({
  index,
  fieldArray,
  onClone,
}: FieldArrayControlsProps<TFieldValues, TFieldArrayName>) => {
  return (
    <div className="d-flex justify-content-end gap-2">
      <button
        className="btn btn-outline-secondary"
        disabled={index === 0}
        style={{
          border: '2px solid var(--color-primary) !important',
        }}
        onMouseDown={() => fieldArray.swap(index, index - 1)}
        onClick={(e) => {
          e.stopPropagation()
          e.preventDefault()
        }}
      >
        <i
          className="icofont-arrow-up"
          style={{
            color: 'var(--color-primary)',
          }}
        ></i>
      </button>
      <button
        className="btn btn-outline-secondary"
        disabled={index === fieldArray.fields.length - 1}
        style={{
          border: '2px solid var(--color-primary) !important',
        }}
        onMouseDown={() => fieldArray.swap(index, index + 1)}
        onClick={(e) => {
          e.stopPropagation()
          e.preventDefault()
        }}
      >
        <i
          className="icofont-arrow-down"
          style={{
            color: 'var(--color-primary)',
          }}
        ></i>
      </button>
      {onClone && (
        <button
          className="btn btn-outline-secondary"
          style={{
            border: '2px solid var(--color-primary) !important',
          }}
          onMouseDown={onClone}
          onClick={(e) => {
            e.stopPropagation()
            e.preventDefault()
          }}
        >
          <i
            className="icofont-ui-copy"
            style={{
              color: 'var(--color-primary)',
            }}
          ></i>
        </button>
      )}
      <button
        className="btn btn-outline-secondary"
        style={{
          border: '2px solid var(--color-primary) !important',
        }}
        onMouseDown={() => fieldArray.remove(index)}
        onClick={(e) => {
          e.stopPropagation()
          e.preventDefault()
        }}
      >
        <i className="icofont-ui-delete text-danger"></i>
      </button>
    </div>
  )
}

export const FieldArrayControls = memo(FieldArrayControlsComponent) as <
  TFieldValues extends FieldValues,
  TFieldArrayName extends FieldArrayPath<TFieldValues>,
>(
  props: FieldArrayControlsProps<TFieldValues, TFieldArrayName>,
) => React.ReactElement
